<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:วัน-เวลาทำ MT -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">วัน-เวลาทำ MT :</label>
                <span class="form-control-plaintext">{{ mtDate }}</span>
              </div>
            </div>
            <!-- End:วัน-เวลาทำ MT -->

            <!-- Begin:ชื่อ-สกุลผู้ทำ MT -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ชื่อ-สกุลผู้ทำ MT :</label>
                <span class="form-control-plaintext">{{ createUser }}</span>
              </div>
            </div>
            <!-- End:ชื่อ-สกุลผู้ทำ MT -->

            <!-- Begin:รูปลายเซ็นต์-->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">รูปลายเซ็นต์ :</label>
                <br />
                <a
                  href="#"
                  @click.prevent="pictureModal(signatureFileUrl)"
                  title="รูปภาพ"
                  v-if="signatureFileUrl "
                  >Link</a
                >

                
              </div>
            </div>
            <!-- End:รูปลายเซ็นต์ -->
          </div>
          <hr />
          <!-- failureMachineCodes อาการเสีย -->
          <div v-if="failureMachineCodes.length > 0">
            <div class="kt-section kt-section--first">
              <h3 class="kt-section__title">
                อาการเสีย:
              </h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table
                      class="table table-sm table-striped table-bordered table-hover table-checkable"
                    >
                      <thead>
                        <tr>
                          <th class="text-center" width="5%">ลำดับ</th>
                          <th class="text-center" width="15%">อาการเสีย</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(fmc, i) in failureMachineCodes" :key="i">
                          <td class="text-center stock-item-td">
                            {{ i + 1 }}
                          </td>
                          <td
                            class="stock-item-td text-left"
                            v-if="
                              fmc.failureMachineCode != 'FAILURE_MACHINE_OTHER'
                            "
                          >
                            {{ fmc.failureMachineName }}
                          </td>
                          <td
                            class="stock-item-td text-left"
                            v-if="
                              fmc.failureMachineCode == 'FAILURE_MACHINE_OTHER'
                            "
                          >
                            {{ fmc.failureMachineName }} &nbsp; ({{
                              failureMachineOther
                            }})
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- failureMachineReasonCodes  สาเหตุของอาการเสีย -->
          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">
              สาเหตุของอาการเสีย:
            </h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">
                          สาเหตุของอาการเสีย
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="failureMachineReasonCodes.length > 0">
                      <tr
                        v-for="(fmrc, i) in failureMachineReasonCodes"
                        :key="i"
                      >
                        <td class="text-center stock-item-td">
                          {{ i + 1 }}
                        </td>
                        <td class="stock-item-td text-left">
                          {{ fmrc.failureMachineReasonName }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="failureMachineReasonOther">
                      <tr>
                        <td
                          class="text-center stock-item-td"
                          v-if="failureMachineReasonCodes.length == 0"
                        >
                          1
                        </td>
                        <td
                          class="text-center stock-item-td"
                          v-if="failureMachineReasonCodes.length > 0"
                        >
                          {{ failureMachineReasonCodes.length + 1 }}
                        </td>
                        <td class="stock-item-td text-left">
                          {{ failureMachineReasonOther }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Begin:วิธีการแก้ปัญหา -->
          <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="label">วิธีการแก้ปัญหา :</label>
              <span class="form-control-plaintext">{{ resolve }}</span>
            </div>
          </div>
          <!-- End:วิธีการแก้ปัญหา -->
        </div>
      </div>

      <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content mr-4">
            <div class="modal-header">
              <h5 class="modal-title">ภาพถ่าย</h5>
              <button type="button" class="close" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body"> 
              <img :src="modalImageURL" class="img-thumbnail mb-3" style="height: auto; width: auto;"> 
            </div>
            <div class="modal-footer">
              <button type="button" data-dismiss="modal" class="btn btn-secondary"  aria-label="Close" @click="closeModal"><i class="la la-close"></i> ปิดหน้าต่าง
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    var self = this;
    return {
      createUser: null,
      mtDate: null,
      signatureFileUrl: null,
      barcodeShopMappingId: null,
      resolve: null,
      failureMachineOther: null,
      failureMachineReasonOther: null,
      failureMachineCodes: [],
      failureMachineReasonCodes: [],
      //
      pmStartDate: null,
      pmEndDate: null,
      diffMins: null,
      machineSpares: [],
      dispensers: [],
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .post("/Api/PM/MTDetail", {
        BarcodeShopMappingId: this.$route.params.id2,
        PMCheckInId: this.$route.params.id,
      })
      .then(function(response) {
        if (response.status == 200) {
          //console.log(response.data);
          if (response.data) {
            self.barcodeShopMappingId = response.data.barcodeShopMappingId;
            self.createUser = response.data.createUser;
            self.mtDate = response.data.mtDateFormat;
            self.resolve = response.data.resolve;
            self.signatureFileUrl = response.data.signatureFileUrl;
            self.failureMachineOther = response.data.failureMachineOther; 
            self.failureMachineReasonOther =
              response.data.failureMachineReasonOther;
            if (
              response.data.failureMachineCodes != null &&
              response.data.failureMachineCodes.length > 0
            ) {
              response.data.failureMachineCodes.forEach((el) => {
                self.failureMachineCodes.push({
                  failureMachineId: el.failureMachineId,
                  failureMachineCode: el.failureMachineCode,
                  failureMachineName: el.failureMachineName,
                });
              });
            }
            if (
              response.data.failureMachineReasonCodes != null &&
              response.data.failureMachineReasonCodes.length > 0
            ) {
              response.data.failureMachineReasonCodes.forEach((el) => {
                self.failureMachineReasonCodes.push({
                  failureMachineReasonId: el.failureMachineReasonId,
                  failureMachineReasonCode: el.failureMachineReasonCode,
                  failureMachineReasonName: el.failureMachineReasonName,
                });
              });
            }
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการทำ MT", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการทำ MT ได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
  methods: {
    showModal(imageURL) {
    
    this.modalImageURL = imageURL;
    this.isFromImageModal = true;
    $('#imageModal').modal('show');
    $('#imageModal').on('hidden.bs.modal', () => {
      $('body').addClass('modal-open');
    });
  },
  closeModal() {
    $('#imageModal').modal('hide');
  },
    pictureModal(fileUrl) {
      let router = this.$router;
      //console.log(fileUrl);
      if (fileUrl != null) {
        router.push({
          path: `/PM/PMCheckIn/${this.$route.params.id}/MTDetail/${
            this.$route.params.id2
          }/Picture/${encodeURIComponent(fileUrl)}`,
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    },
  },
};
</script>
<style lang="css">
.stock-item-td {
  color: #6c7293;
}
</style>



// WEBPACK FOOTER //
// App/Components/PM/MTDetail.vue